export enum Font {
    Poppins = "'Poppins', sans-serif",
    SpaceGrotesk = "'Space GroteskVariable', sans-serif",

    Inter = "'Inter Variable', sans-serif",
}
